angular.module("ainapp")
    .controller("remindersController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService",
            function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService) {

            $scope.PageName = "Reminders";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }


            $scope.Init = function () {
                $scope.Country = {
                    Date: new Date(),
                    Remarks: "",
                    UserId: $scope.TokenInfo.UserId,
                    Type: "",
                }

                $scope.load = 0;

            }
            $scope.Init();


            $scope.KendoSource = new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function (o) {

                        o.data.UserId = $scope.TokenInfo.UserId;
                        MainService.RemindersInView(o.data).then(function (response) {
                            o.success(response.data);
                        }, function (err) {
                            o.success({
                                Data: []
                            });
                            toastr.error("NetworkError");
                        })
                    },

                },
                change: function (data) {},
                schema: {
                    data: "Data",
                    total: "Total",
                    model: {
                        id: "Id",
                        fields: {
                            Date: {
                                type: "date",
                                editable: false,
                            },
                            Type: {
                                type: "string",
                                editable: false,
                            },
                            Remarks: {
                                type: "string",
                                editable: false,
                            },

                        }
                    }
                },
                serverPaging: true,
                serverSorting: true,
                serverFiltering: true,
                pageSize: 20,
            });

            $scope.KendoGridOptions = {

                editable: false,
                pageable: true,
                toolbar: ["excel"],
                height: 600,
                resizable: true,
                dataSource: $scope.KendoSource,
                pageSize: 20,
                pageable: {
                    input: false,
                    refresh: true,
                    pageSizes: true,
                    info: true,
                },
                sortable: true,
                scrollable: true,
                filterable: true,
                groupable: false,
                columnMenu: {
                    filterable: false,
                    filterable: true,
                },

                columns: [
                    {
                        field: "Date",
                        title: "Date",
                        template: "#= kendo.toString(kendo.parseDate(Date, 'yyyy-MM-dd'), 'dd/MM/yyyy') #",
                        },
                    {
                        field: "Type",
                        title: "Type",
                        },
                    {
                        field: "Remarks",
                        title: "Remarks",
                        },
                    {
                        title: "Options",
                        headerTemplate: "{{LanguageData.Options}}",
                        template: "<button class=' btn-default btn-sm fa fa-pencil' ng-click='Edit(dataItem)'> </button> <button class=' btn-default btn-sm fa fa-trash'  ng-click='DeleteAccType(dataItem)'></button>  ",
                        width: '80px'
                        },
                    ],
            };

            $scope.Update = function () {
                $("#Kendo-Grid").data("kendoGrid").dataSource.sync();
            }
            $scope.Cancel = function () {
                $("#Kendo-Grid").data("kendoGrid").dataSource.cancelChanges();
            }

            $scope.SelectedDataForDelete = {};
            $scope.DeleteAccType = function (data) {
                if (!$scope.PageAccessInfo.IsRemove) {
                    toastr.info("You Dont Have Access To Delete Data, Please Contact Admin");
                } else {
                    $scope.SelectedDataForDelete = data;
                    $("#deleteModal").modal("show");
                }
            }



            $scope.deleteWithConfirm = function () {
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });

                MainService.DeleteReminder($scope.SelectedDataForDelete.Id).then(function (response) {
                    if (response.data) {
                        $('#deleteModal').modal('hide');
                        toastr.success("Deleted");
                        $("#Kendo-Grid").data("kendoGrid").dataSource.read();
                        $scope.SelectedDataForDelete = {};
                    }
                    $.LoadingOverlay("hide");
                }, function (err) {
                    toastr.error("Network Error");
                    $scope.load = 0;
                    $.LoadingOverlay("hide");

                });
            }

            $scope.Edit = function (data) {
                $scope.Country = data;
            }


            $scope.AddData = function () {
                if (!$scope.PageAccessInfo.IsAdd && !$scope.Country.Id > 0) {
                    toastr.info("You Dont Have Access To Add Data, Please Contact Admin");
                } else if (!$scope.PageAccessInfo.IsEdit && $scope.Country.Id > 0) {
                    toastr.info("You Dont Have Access To Edit Data, Please Contact Admin");
                } else {
                    if ($scope.Country.Type == "") {
                        toastr.warning("Enter Type");
                    } else
                    if ($scope.Country.Remarks == "") {
                        toastr.warning("Enter  Remarks");
                    } else {

                        $.LoadingOverlay("show", {
                            image: "images/load.gif",
                        });

                        $scope.Country.DateString = $scope.extractDate($scope.Country.Date);

                        MainService.AddReminder($scope.Country).then(function (response) {
                            if (response.data) {
                                $("#Kendo-Grid").data("kendoGrid").dataSource.read();
                                toastr.success("Success");
                                $scope.Init();
                            } else {
                                toastr.error("Error");
                            }
                            $.LoadingOverlay("hide");

                        }, function (err) {
                            toastr.error("Network Error");
                            $.LoadingOverlay("hide");
                        });
                    }
                }
            }

        }])
